import { useBHNavbarContext } from '@rover/shared/js/ssr/BaseTemplate/context/BHNavbarContext';

import BhNavBarBanner from './NavbarBannerBH';

const NavbarBannerBHSSR: React.FC = () => {
  const { isBrightHorizonsNavigation, pageName, startDate } = useBHNavbarContext();
  return (
    <BhNavBarBanner
      startDate={startDate}
      isBrightHorizonsNavigation={isBrightHorizonsNavigation}
      isBhHub={pageName === 'ssr-bh-hub'}
    />
  );
};

export default NavbarBannerBHSSR;
